// @flow
import * as React from 'react';

export function useIsMobile(query: string = '(max-width: 62.5em)'): boolean {
  const getMatch = (): boolean =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false;

  const [isMobile, setIsMobile] = React.useState<boolean>(getMatch);

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return () => {};
    }

    const mql: MediaQueryList = window.matchMedia(query);

    const listener = (e: MediaQueryListEvent): void => {
      setIsMobile(e.matches);
    };

    mql.addListener(listener);
    setIsMobile(mql.matches);

    return () => {
      mql.removeListener(listener);
    };
  }, [query]);

  return isMobile;
}
